import React, { useRef, useEffect, useState } from "react";
import { useInView } from "framer-motion";
import './style.css'
export default function YouTubeScrollPlayer() {
  const ref = useRef(null);
  const isInView = useInView(ref, { threshold: 0.5 }); // Visible à 50%
  const [src, setSrc] = useState("");

  useEffect(() => {
    if (isInView) {
      // ✅ Active autoplay quand visible
      setSrc("https://www.youtube.com/embed/eQ-ARdKHjgQ?autoplay=1&mute=1");
    } else {
      // 🧹 Stoppe la vidéo quand on quitte la zone
      setSrc("");
    }
  }, [isInView]);

  return (
    <div
      ref={ref}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "60px",
      }}
    >
      {src && (
        <iframe
          src={src}
          title="Présentation Ellouze Alu"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
         
          allowFullScreen
          style={{
            borderRadius: "4px",
            transition: "transform 0.5s ease",
          }}
        ></iframe>
      )}
    </div>
  );
}
